import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ItemList from '../components/ItemList';
import ItemDetail from '../components/ItemDetail';
import ItemForm from '../components/ItemForm';

const ItemsPage: React.FC = () => {
  const location = useLocation();
  
  // If the path is exactly "/settings/items", redirect to "/settings/items/"
  // to ensure consistent routing
  if (location.pathname === '/settings/items') {
    return <Navigate to="/settings/items/" replace />;
  }

  return (
    <Routes>
      <Route index element={<ItemList />} />
      <Route path="new" element={<ItemForm />} />
      <Route path=":id" element={<ItemDetail />} />
      <Route path=":id/edit" element={<ItemForm />} />
      <Route path="*" element={<Navigate to="./" relative="path" replace />} />
    </Routes>
  );
};

export default ItemsPage;
